import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { addSuffix, formatCurrency, generateId } from '../../../utility/functions';
import Table from '../../../table/Table';
import LinkTo from '../../../forms/LinkTo';
import Col from '../../../layout/Col';

const Activity = ({ ...props }) => {

    const tableConfig = {
        endpoint: QuestRoute.reports.mobile.activity,
        isReport: true,
        headers: [
            {
                label: 'Account',
                propKey: 'name',
            }, {
                label: 'Email',
                propKey: 'email',
            }, {
                label: 'Club',
                propKey: 'clubName',
                options: true
            }, {
                label: 'Club Price',
                propKey: 'packagePrice',
                options: true
            }, {
                label: 'Use Count',
                propKey: 'useCount',
                sortBy: true,
                ascending: false
            }, {
                label: 'Revenue',
                propKey: 'revenue',
                type: 'number'
            }, {
                label: 'Average Revenue',
                propKey: 'averageRevenue',
                type: 'number',
            }, {
                label: 'Billing Day',
                propKey: 'billingDay',
                show: false
            },
        ],
        sticker: [
            {
                label: 'Total Club Uses',
                color: '#21D59B',
                callback: (data) => data.reduce((a, b) => b.useCount + a, 0)
            }, {
                label: 'Average Revenue Per Wash',
                color: '#21D59B',
                callback: (data) => {
                    return formatCurrency(data.reduce((a, b) => a + b.revenue, 0)/(data.reduce((a, b) => a + b.useCount, 0) || data.length) || 0)
                }
            }, {
                label: 'Average Revenue Per Member',
                color: '#21D59B',
                callback: (data) => formatCurrency(data.reduce((a, b) => a + b.revenue, 0) / data.length || 0)
            },
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>
                    <LinkTo
                        target='_blank'
                        customerId={e.userId}
                    >
                        {e.name}
                    </LinkTo>
                </td>
                <td>{e.email}</td>
                <td>{e.clubName}</td>
                <td>{formatCurrency(e.packagePrice)}</td>
                <td>{e.useCount}</td>
                <td>{formatCurrency(e.revenue)}</td>
                <td>{formatCurrency(e.averageRevenue)}</td>
                <td>{addSuffix(e.billingDay)}</td>
            </tr>
        )
    }

    return (
        <Col style={{ width: '100%' }}>
            {/* <Bar /> */}
            <Table config={tableConfig} />
        </Col>
    );
}

export default Activity;